export default __webpack_public_path__ + "static/media/login-grungard4.87d7c322.png";